module.exports = __webpack_public_path__ + "d455b3ec38714e92508ed4af89801337.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-108@2x.png
// module id = 493
// module chunks = 0